import React, {useState} from 'react'
import './App.scss'
import {Router, Switch, Route, NavLink} from 'react-router-dom'
import HomePageContainer from './app/home/components/HomePageContainer'
import PrintPageContainer from './app/print/component/PrintPageContainer'
import MarkUnprintedPageContainer from './app/mark-unprinted/MarkUnprintedPageContainer'
import OrderItemPageContainer from './app/order-item/component/OrderItemPageContainer'
import OrderLabelPageContainer from './app/order-label-v2/components/OrderLabelPageContainer'
import LabelsPageContainer from './app/labels/components/LabelsPageContainer'
import BasketsPageContainer from './app/baskets/components/BasketsPageContainer'
import MergerPageContainer from "./app/merger-v2/components/MergerPageContainer"
import BasketDetailPageContainer from "./app/basket-detail-v2/components/BasketDetailPageContainer"
import BatchesMarkPrinted from './app/batches-mark-printed/components/MarkPrinted'
import BatchesMarkQc from './app/batches-mark-qc-v3/components/MarkQC'
import BatchesPageContainer from './app/batchesV3/components/BatchesPageContainerV3'
import BatchPage from "./app/batch/components/BatchPage"
import PartnersPage from './app/partners/components/PartnersPage'
import PartnerContainer from './app/partner/components/PartnerContainer'
import UpdateBatchesContainer from "./app/update-batches/components/UpdateBatchesContainer"
import getHistory from './helpers/rounting/getHistory'
import MarkItemPrintedContainer from './app/mark-item-printed/components/MarkItemPrintedContainer'
import BatchesMarkTransferredContainer from './app/batches-mark-transferred/component/BatchesMarkTransferredContainer'
import DashboardContainer from './app/dashboard/components/DashboardContainer'
import ReGenerateContainer from './app/re-generate/component/ReGenerateContainer'
import ListJobContainer from "./app/list-job-labels/components/ListJobContainer"
import JobsGeneratedContainer from './app/jobs-generated/components/JobsGeneratedContainer'
import InCardContainer from './app/in-card/components/InCardContainer'
import StaticBatchesContainer from "./app/static-batches/components/StaticBatchesContainer"
import BatchReproductionContainer from "./app/batch-reproduction/components/BatchReproductionContainer"
import ItemReproductionContainer from "./app/item-reproduction/components/ItemReproductionContainer"
import LazeCuttingPageContainer from "./app/laze-cutting/components/LazeCuttingPageContainer"
import ListLazePageContainer from "./app/list-laze/components/ListLazePageContainer"
import ItemPieceErrorContainer from './app/items-piece-error/components/ItemPieceErrorContainer'
import ItemsErrorContainer from "./app/items-error/components/ItemsErrorContainer"
import LoginContainer from "./app/login/components/LoginContainer"
import EnsureLoggedIn from './app/shared/EnsureLoggedIn'
import UsersContainers from "./app/users/components/UsersContainers"
import {getLocalData} from "./services/StorageServices"
import MenuRight from "./helpers/MenuRight"
import MarkPackagedPageContainer from "./app/packing/components/MarkPackagedPageContainer"
import ListPackagedPageContainer from "./app/packing/components/ListPackagedPageContainer"
import PackingItemPageContainer from './app/packing-item/components/PackingItemPageContainer'
import MarkOrdersPackagedPageContainer from "./app/orders-packing/components/MarkPackagedPageContainer"
import SewingRepairContainer from './app/sewing-repair/components/SewingRepairContainer'
import SewingRepairInBatchContainer from './app/sewing-repair-in-batch/components/SewingRepairInBatchContainer'
import MexPageContainer from './app/mex/components/MexPageContainer'
import ListMexPageContainer from './app/list-mex/components/ListMexPageContainer'
import RuleCreateBatchContainer from './app/rule-create-batch/components/RuleCreateBatchContainer'
import CreateRuleContainer from './app/rule-create-batch/components/Actions/CreateRuleContainer'
import UpdateRuleContainer from './app/rule-create-batch/components/Actions/UpdateRuleContainer'
import LazeCuttingErrorContainer from './app/list-laze-error/components/LazeCuttingErrorContainer'
import StatisticsAddBasketContainer from './app/basket-statistics/components/StatisticsAddBasketContainer'
import StatisticsDeleteBasketContainer from './app/basket-statistics/components/StatisticsDeleteBasketContainer'
import StatisticsUncompleteBasketContainer from './app/basket-statistics/components/StatisticsUncompleteBasketContainer'
import BatchesMarkPeriodsContainer from './app/batches-mark-periods/components/BatchesMarkPeriodsContainer'
import ListStageCompleteContainer from './app/list-periods/components/ListPeriodsContainer'
import UploadArtworkContainer from './app/upload-artwork/components/UploadArtworkContainer'
import OddBatchContainer from './app/odd-batch/components/OddBatchContainer'
import {Tooltip, Menu, Dropdown, Icon} from "antd"
import { getLocalIP } from './helpers/getLocalIP'
import MarkErrorItemContainer from './app/mark-error-item/components/MarkErrorItemContainer'
import {parseJwt} from "./helpers/parseToken"
import RequestPhotoContainer from './app/request-photo/components/RequestPhotoContainer'
import MarkImprovedContainer from './app/mark-improved/components/MarkImprovedContainer'

getLocalIP(1).then(ip => sessionStorage.setItem('lanIp', ip))

function App() {
    const history = getHistory()
    const tokenData = getLocalData('accessToken')
    const [token, setToken] = useState(tokenData)

    const role = parseJwt(getLocalData('accessToken')).roles || []
    const isAdmin = role.some(item => item.name === "fac_admin")

    const _setToken = (token) => {
        setToken(token)
    }

    const onClick = (e) => {
        console.log(e)
    }
        const menu = (
        <Menu>
            {/* <Menu.Item key="0">
                <NavLink exact to="/order-item" className="nav-link">
                    Order item
                </NavLink>
            </Menu.Item>
            <Menu.Divider /> */}
            <Menu.Item key="1">
                <NavLink exact to="/order-label" className="nav-link">
                    Order label
                </NavLink>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key="3">
                <NavLink exact to="/in-card" className="nav-link">
                    In card
                </NavLink>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="App bg-light">
            <Router history={getHistory()}>
                <Switch>
                    <Route exact path="/login">
                        <LoginContainer onChangeToken={_setToken}/>
                    </Route>
                    <EnsureLoggedIn>
                        <div className="MenuHeader">
                            {
                                history.location.pathname !== '/batches/mark-printed' && <header>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 MenuHeaderCustom">
                                                <ul className="nav MainMenu">
                                                    <li className="nav-item">
                                                        <NavLink exact to="/dashboard" className="nav-link">
                                                            Dashboard
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/" className="nav-link">Home</NavLink>
                                                    </li>
                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/order-item" className="nav-link">
                                                            Order item
                                                        </NavLink>
                                                    </li> */}
                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/order-label" className="nav-link">
                                                            Order label
                                                        </NavLink>
                                                    </li> */}
                                                    <li className="nav-item">
                                                        <NavLink exact to="/labels"
                                                                 className="nav-link">Labels</NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink to="/baskets" className="nav-link">Baskets</NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/merger" className="nav-link">Gộp
                                                            đơn</NavLink>
                                                    </li>
                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/in-card" className="nav-link">In
                                                            card</NavLink>
                                                    </li> */}
                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/updatebatches" className="nav-link">
                                                            Cập nhật trạng thái Lô
                                                        </NavLink>
                                                    </li> */}
                                                    <li className="nav-item">
                                                        <NavLink exact to="/batches" className="nav-link">Lô</NavLink>
                                                        {/*<ul className="submenu">*/}
                                                        {/*    <li className="nav-item">*/}
                                                        {/*        <NavLink exact to="/batches/packing" className="nav-link" onClick={onClick}>Đóng*/}
                                                        {/*            thùng</NavLink>*/}
                                                        {/*    </li>*/}
                                                        {/*    <li className="nav-item">*/}
                                                        {/*        <NavLink exact to="/batches/packing/list" className="nav-link" onClick={onClick}>Danh*/}
                                                        {/*            sách đóng thùng</NavLink>*/}
                                                        {/*    </li>*/}
                                                        {/*</ul>*/}
                                                    </li>
                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/laze-cutting" className="nav-link">Cắt
                                                            Laze</NavLink>
                                                    </li> */}

                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/mex" className="nav-link">Ép Mex</NavLink>
                                                    </li> */}

                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/mark-periods" className="nav-link">Hoàn thiện</NavLink>
                                                    </li>

                                                    <li className="nav-item">
                                                        <NavLink exact to="/sewing-repair" className="nav-link">Sửa may</NavLink>
                                                    </li> */}
                                                                                                        
                                                    {/* <li className="nav-item">
                                                        <NavLink exact to="/markitemprinted" className="nav-link">
                                                            QC sau ép
                                                        </NavLink>
                                                    </li> */}
                                                    <li className="nav-item">
                                                        <NavLink exact to="/batches/mark-qc" className="nav-link">
                                                            QC hoàn thành
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/mark-error" className="nav-link">
                                                            Đánh dấu lỗi
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/mark-improved" className="nav-link">
                                                            Hoàn thiện
                                                        </NavLink>
                                                    </li>
                                                    <li className='nav-item'>
                                                        <NavLink exact to="/request-photo" className="nav-link">
                                                            Chụp ảnh
                                                        </NavLink>
                                                    </li>
                                                    <li className='nav-item'>
                                                        <Tooltip title="Đóng gói theo đơn">
                                                            <NavLink exact to='/orders/packing' className='nav-link'>Đóng
                                                                gói</NavLink>
                                                        </Tooltip>
                                                    </li>
                                                    <li className="nav-item">
                                                        <NavLink exact to="/partners" className="nav-link">
                                                            Đối tác
                                                        </NavLink>
                                                    </li>
                                                    <li className="nav-item">
                                                        <Dropdown overlay={menu} trigger={['click']}>
                                                            <NavLink exact to="Khac" onClick={e => e.preventDefault()} className="nav-link">
                                                                Khác <Icon type="down" />
                                                            </NavLink>
                                                        </Dropdown>
                                                    </li>
                                                    {/* <li className="nav-item">
                                                    </li> */}
                                                </ul>
                                                <MenuRight token={token}/>
                                            </div>
                                        </div>
                                    </div>
                                </header>
                            }

                            <main>
                                <Switch>
                                    <Route exact path="/batches/packing" component={MarkPackagedPageContainer}/>

                                    <Route exact path="/batches/packing/list" component={ListPackagedPageContainer}/>

                                    <Route exact path="/orders/packing" component={MarkOrdersPackagedPageContainer}/>

                                    <Route exact path="/">
                                        <HomePageContainer history={history}/>
                                    </Route>

                                    <Route exact path="/mark-printed">
                                        <PrintPageContainer/>
                                    </Route>

                                    <Route exact path="/unmark-printed">
                                        <MarkUnprintedPageContainer/>
                                    </Route>

                                    <Route exact path="/order-item" component={OrderItemPageContainer}/>

                                    <Route exact path="/order-label" component={OrderLabelPageContainer}/>

                                    <Route exact path="/labels" component={LabelsPageContainer}/>

                                    <Route exact path="/baskets" component={BasketsPageContainer}/>

                                    <Route exact path="/baskets/:id" component={BasketDetailPageContainer}/>

                                    <Route exact path="/merger" component={MergerPageContainer}/>

                                    <Route exact path="/batches/mark-printed" component={BatchesMarkPrinted}/>

                                    <Route exact path="/batches/mark-qc" component={BatchesMarkQc}/>

                                    <Route exact path="/batches" component={BatchesPageContainer}/>

                                    <Route
                                        exact path="/batches/mark-transferred"
                                        component={BatchesMarkTransferredContainer}
                                    />

                                    <Route exact path="/batches/:id" component={BatchPage}/>

                                    <Route exact path="/partners" component={PartnersPage}/>

                                    <Route exact path="/markitemprinted" component={MarkItemPrintedContainer}/>

                                    <Route exact path="/partners/:id" component={PartnerContainer}/>

                                    <Route exact path="/updatebatches" component={UpdateBatchesContainer}/>

                                    <Route exact path="/dashboard" component={DashboardContainer}/>

                                    {isAdmin && <Route exact path="/re-generate" component={ReGenerateContainer}/>}

                                    <Route exact path="/list-job-labels" component={ListJobContainer}/>

                                    <Route exact path="/jobs-generated" component={JobsGeneratedContainer}/>

                                    <Route exact path="/in-card" component={InCardContainer}/>

                                    <Route exact path="/static-batches" component={StaticBatchesContainer}/>

                                    {/* <Route exact path="/batch-reproduction" component={BatchReproductionContainer}/> */}

                                    <Route exact path="/items-error" component={ItemsErrorContainer}/>

                                    <Route exact path="/users" component={UsersContainers}/>

                                    <Route exact path="/item-reproduction" component={ItemReproductionContainer}/>

                                    <Route exact path="/laze-cutting" component={LazeCuttingPageContainer}/>

                                    <Route exact path="/mex" component={MexPageContainer}/>

                                    <Route exact path='/list-laze' component={ListLazePageContainer}/>

                                    <Route exact path='/item-piece-error' component={ItemPieceErrorContainer}/>

                                    <Route exact path="/list-laze" component={ListLazePageContainer}/>

                                    <Route exact path="/list-mex" component={ListMexPageContainer}/>

                                    <Route exact path="/packing-item" component={PackingItemPageContainer}/>

                                    <Route exact path="/sewing-repair" component={SewingRepairContainer}/>
                                    
                                    <Route exact path="/sewing-repair-in-batch" component={SewingRepairInBatchContainer}/>

                                    <Route exact path="/list-rule-create-batch" component={RuleCreateBatchContainer}/>

                                    <Route exact path="/create-rule" component={CreateRuleContainer}/>

                                    <Route exact path="/edit-rule/:id" component={UpdateRuleContainer}/>

                                    <Route exact path="/list-laze-error" component={LazeCuttingErrorContainer}/>

                                    <Route exact path="/statistics-add-basket" component={StatisticsAddBasketContainer}/>

                                    <Route exact path="/statistics-delete-basket" component={StatisticsDeleteBasketContainer}/>

                                    <Route exact path="/statistics-uncomplete-basket" component={StatisticsUncompleteBasketContainer}/>

                                    <Route exact path="/mark-periods" component={BatchesMarkPeriodsContainer}/>
                                    
                                    <Route exact path="/list-periods" component={ListStageCompleteContainer}/>

                                    <Route exact path="/upload-artwork" component={UploadArtworkContainer}/>

                                    <Route exact path="/odd-batch" component={OddBatchContainer}/>

                                    <Route exact path="/mark-error" component={MarkErrorItemContainer}/>
                                    
                                    <Route exact path="/request-photo" component={RequestPhotoContainer}/>

                                    <Route exact path="/mark-improved" component={MarkImprovedContainer}/>

                                </Switch>
                            </main>
                        </div>
                    </EnsureLoggedIn>
                </Switch>
            </Router>
        </div>
    )
}

export default App
